import { LifecycleStage } from './LifecycleStage';

/** v7.5: reviewed cross-system lifecycle view. */
export function SellStage() { return <LifecycleStage stage="sell" />; }
